<template>
  <div>
    <el-menu
      class="el-menu-vertical-demo"
      :default-active="activeRoute"
      :router="true"
      @open="handleOpen"
      @close="handleClose"
      background-color="#ffffff"
      text-color="#393D52"
      active-text-color="#2196f3"
    >
      <el-menu-item index="list">
        <i class="el-icon-s-order"></i>
        <span>推荐记录</span>
      </el-menu-item>
      <el-menu-item
        index="adviser"
        v-if="$store.state.userInfo.role === 'admin' || $store.state.userInfo.role === 'local_admin'"
      >
        <i class="el-icon-user"></i>
        <span>用户列表</span>
      </el-menu-item>
      <el-menu-item index="localAdmin" v-if="$store.state.userInfo.role === 'admin'">
        <i class="el-icon-user"></i>
        <span>地区管理员</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeRoute: ""
    };
  },
  mounted() {
    setTimeout(() => {
      this.activeRoute = this.$route.path.split("/")[1];
    }, 300);
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-menu-item {
  &:hover {
    background: #d7ebff !important;
  }
}
.el-menu-item.is-active {
  background: #e8f4ff !important;
}
</style>